import React, { useState, useEffect } from 'react'
import parse from 'html-react-parser';

function TemplateThree(props) {

  const initialState = {
    userName: "Jhon Doe",
    eventName: "Hotel Party",
    contentBodyText: "Here is your photo",
    buttonText: "Share Your Photo",
    markupText: "Brought you by The Haylo",
    footerText: `&copy; 2021 <a href="https://thehaylo.com.au" style="color: #fff">The Haylo</a>. All Rights Reserved`
  }
  const [emailTemplateContent, setContent] = useState({ ...initialState })

  const [selectedState, setSelectedState] = useState(null)

  const selectElement = (stateName, theValue) => {
    props.setChangeState(stateName, theValue)

    setSelectedState(stateName)

  }

  useEffect(() => {
    if (props.changeStateData !== emailTemplateContent[`${selectedState}`]) {
      if (props.changeStateData != '') {
        let content = { ...emailTemplateContent, [`${selectedState}`]: props.changeStateData }
        setContent(content)
        props.copyEditedData(content)
      }
    }

    if (props.reset === true) {
      setContent({ ...initialState })
    }

  }, [props])

  return (
    <center style={{ width: '100%', backgroundColor: "#f1f1f1" }}>
      <div class="es-wrapper-color">
        <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style={{ fontFamily: "'QuickSand', sans-serif" }}>
          <tbody>
            <tr>
              <td class="esd-email-paddings" valign="top">
                <table cellpadding="0" cellspacing="0" class="es-content esd-header-popover" align="center">
                  <tbody>
                    <tr>
                      <td class="es-adaptive esd-stripe" esd-custom-block-id="24" align="center">
                        <table class="es-content-body" style={{ backgroundColor: "rgb(206,162,82)" }} width="600" cellspacing="0" cellpadding="0" bgcolor="rgba(0,0,0,.8)" align="center">
                          <tbody>
                            <tr>
                              <td class="esd-structure es-p10" align="left">
                                <table class="es-left" cellspacing="0" cellpadding="0" align="left" width="100%">
                                  <tbody>
                                    <tr>
                                      <td class="esd-container-frame" width="100%" align="left">
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                          <tbody>
                                            <tr>
                                              <td class="es-infoblock esd-block-text" align="center" style={{ padding: "2.5em" }}>
                                                <span class="subheading editable" style={{ display: 'block', fontSize: '28px', textTransform: 'uppercase', letterSpacing: '2px', color: '#fff', fontWeight: 'bold', marginBottom: "10px" }} onClick={selectElement.bind(this, 'userName', emailTemplateContent.userName)}>{parse(emailTemplateContent.userName)}</span>
                                                <span class="subheading editable" style={{ display: 'inline-block', fontSize: '28px', textTransform: 'uppercase', letterSpacing: '2px', color: '#fff', borderBottom: "2px solid #fff" }} onClick={selectElement.bind(this, 'eventName', emailTemplateContent.eventName)}>{parse(emailTemplateContent.eventName)}</span>
                                                <h2 class="editable" style={{ fontSize: '18px', color: '#ffffff', fontWeight: 'light', textTransform: "uppercase" }}>21-09-2021 18:00</h2>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table class="es-content esd-header-popover" cellspacing="0" cellpadding="0" align="center">
                  <tbody>
                    <tr>
                      <td class="esd-stripe" esd-custom-block-id="3109" align="center">
                        <table class="es-content-body" style={{ backgroundColor: "#ffffff" }} width="600" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                          <tbody>
                            <tr>
                              <td class="esd-structure es-p20t es-p20b es-p40r es-p40l" esd-general-paddings-checked="true" align="left">
                                <table width="100%" cellspacing="0" cellpadding="0">
                                  <tbody>
                                    <tr>
                                      <td class="esd-container-frame" width="520" valign="top" align="center">
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                          <tbody>
                                            <tr>
                                              <td class="esd-block-text" align="left" style={{
                                                padding: '1.5em',
                                                textAlign: 'center',
                                                fontSize: '15px',
                                                lineHeight: '26px',
                                                color: '#7a7a7a'
                                              }}>
                                                <p class="editable" style={{ borderBottom: '1px solid #ccc', fontSize: '16px' }} onClick={selectElement.bind(this, 'contentBodyText', emailTemplateContent.contentBodyText)}>{parse(emailTemplateContent.contentBodyText)}</p>

                                                <span>
                                                  <img src="https://img.freepik.com/free-photo/groom-black-tuxedo-hugs-tender-stunning-bride-while-they-stand_8353-8050.jpg?size=626&ext=jpg" width="500" className="attach-image" alt="s" />
                                                </span>

                                              </td>
                                            </tr>
                                            <tr>
                                              <td class="esd-block-button es-p20t es-p20b" align="center">
                                                <a onClick={selectElement.bind(this, 'buttonText', emailTemplateContent.buttonText)} class="editable" href="#" style={{
                                                  background: '#f3a333',
                                                  color: '#ffffff', padding: '10px 20px', display: 'inline-block',
                                                  marginBottom: '40px', textDecoration: 'none', fontWeight: "bold"
                                                }}>{parse(emailTemplateContent.buttonText)}</a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td class="esd-structure es-p20t es-p20b es-p40r es-p40l" esd-general-paddings-checked="true" align="left">
                                <table width="100%" cellspacing="0" cellpadding="0">
                                  <tbody>
                                    <tr>
                                      <td class="esd-container-frame" width="520" valign="top" align="center">
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                          <tbody>
                                            <tr>
                                              <td class="esd-block-spacer es-p20t es-p20b es-p5r" align="center" style={{ fontSize: "0" }}>
                                                <table width="100%" height="100%" cellspacing="0" cellpadding="0" border="0">
                                                  <tbody>
                                                    <tr>
                                                      <td style={{ borderBottom: '1px solid #ffffff', background: 'rgba(0, 0, 0, 0) none repeat scroll 0% 0%', height: '1px', width: '100%', margin: "0px" }}></td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table cellpadding="0" cellspacing="0" class="es-content esd-header-popover" align="center">
                  <tbody>
                    <tr>
                      <td class="es-adaptive esd-stripe" esd-custom-block-id="24" align="center">
                        <table class="es-content-body" style={{ backgroundColor: "rgb(206, 162, 82)" }} width="600" cellspacing="0" cellpadding="0" bgcolor="rgba(0,0,0,.8)" align="center">
                          <tbody>
                            <tr>
                              <td class="esd-structure es-p10" align="left">
                                <table class="es-left" cellspacing="0" cellpadding="0" align="left" width="100%">
                                  <tbody>
                                    <tr>
                                      <td class="esd-container-frame" width="100%" align="left">
                                        <table width="100%" cellspacing="0" cellpadding="0">
                                          <tbody>
                                            <tr>
                                              <td class="es-infoblock esd-block-text" align="center" style={{ padding: "2.5em" }}>
                                                <span onClick={selectElement.bind(this, 'markupText', emailTemplateContent.markupText)} class="subheading editable" style={{ display: 'inline-block', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '2px', color: "#fff" }}>{parse(emailTemplateContent.markupText)}</span>
                                                <p onClick={selectElement.bind(this, 'footerText', emailTemplateContent.footerText)} class="editable" style={{ color: "#fff" }}>{parse(emailTemplateContent.footerText)}</p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>


              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </center>
  )
}

export default TemplateThree
